export default {"src":"/_next/static/media/no_service.c295fa17.svg","height":219,"width":351,"blurWidth":0,"blurHeight":0};